import { render, staticRenderFns } from "./ProgramMessagesStep.vue?vue&type=template&id=706c9874&scoped=true"
import script from "./ProgramMessagesStep.vue?vue&type=script&lang=js"
export * from "./ProgramMessagesStep.vue?vue&type=script&lang=js"
import style0 from "./ProgramMessagesStep.vue?vue&type=style&index=0&id=706c9874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c9874",
  null
  
)

export default component.exports